<div class="modal-header">
        <h4 class="modal-title">Application Refresh</h4>
    </div>
    <div class="modal-body">
        <p>The version you have running in your browser needs to be updated. Click refresh to update the application.</p>
        <p>If you experience further issues, <a target="_blank" href="https://edulinksolutions.freshdesk.com/support/solutions/articles/13000106472-how-to-clear-cache-and-or-cookies-">click here</a> for more information about resolving the issue.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="confirm()">Refresh</button>
    </div>
